import intl from 'react-intl-universal'
import { getKey } from '~/util/customEmbed'
import { EVIDENTLY_FLAG } from '~/util/constants/keys'

const variantZone = 'variant_zone'

function isVariantZoneActive(settingsResponse) {
  return !!settingsResponse.data.tools.find((tool) => tool === variantZone)
}

function toolbox(settingsService, evidentlyService) {
  this.getItems = async () => {
    const settingsResponse = await settingsService.fetchSettings()
    const features = await evidentlyService.instance()

    const customEmbedItems = Object.entries(
      settingsResponse.data.customEmbed || {}
    ).map(([subtype, customEmbedConfig]) => {
      const icon = customEmbedConfig.icon || 'square'
      return {
        type: 'custom_embed',
        subtype,
        icon: icon !== 'bolt' ? icon : 'sun-o',
        text: customEmbedConfig.caption || subtype,
      }
    })

    const defaultToolList = [
      ...customEmbedItems,
      {
        type: 'header',
        icon: 'header',
        text: intl.get('toolbox.elements.heading'),
      },
      {
        type: 'text',
        icon: 'align-left',
        text: intl.get('toolbox.elements.paragraph'),
      },
      {
        type: 'blockquote',
        icon: 'comment',
        text: intl.get('toolbox.elements.legacyBlockquote'),
      },
      {
        type: 'quote2',
        icon: 'comment',
        text: intl.get('toolbox.elements.blockquote'),
      },
      {
        type: 'image',
        icon: 'picture-o',
        text: intl.get('toolbox.elements.image'),
      },
      {
        type: 'gallery',
        icon: 'th-large',
        text: intl.get('toolbox.elements.gallery'),
      },
      {
        type: 'video',
        icon: 'video-camera',
        text: intl.get('toolbox.elements.video'),
      },
      {
        type: 'raw_html',
        icon: 'file',
        text: intl.get('toolbox.elements.html'),
      },
      {
        type: 'interstitial_link',
        icon: 'external-link-square',
        text: intl.get('toolbox.elements.interstitialLink'),
      },
      {
        type: 'reference',
        icon: 'share-square',
        text: intl.get('toolbox.elements.socialUrl'),
      },
      { type: 'list', icon: 'list', text: intl.get('toolbox.elements.list') },
      { type: 'table', icon: 'th', text: intl.get('toolbox.elements.table') },
      {
        type: 'code',
        icon: 'pencil',
        text: intl.get('toolbox.elements.code'),
      },
      {
        type: 'correction',
        icon: 'fire-extinguisher',
        text: intl.get('toolbox.elements.correction'),
      },
      {
        type: 'quote',
        icon: 'quote-left',
        text: intl.get('toolbox.elements.pullQuote'),
      },
      {
        type: 'numeric_rating',
        icon: 'star-half-o',
        text: intl.get('toolbox.elements.rating'),
      },
      {
        type: 'divider',
        icon: 'minus',
        text: intl.get('toolbox.elements.divider'),
      },
      {
        type: 'link_list',
        icon: 'server fa-flip-horizontal',
        style: {
          paddingInlineStart: '0.5em',
          paddingInlineEnd: '0em',
        },
        text: intl.get('toolbox.elements.link_list'),
      },
    ]

    if (
      features[EVIDENTLY_FLAG.CONDITIONAL_CONTENT] &&
      isVariantZoneActive(settingsResponse)
    ) {
      defaultToolList.push({
        type: variantZone,
        icon: 'newspaper-o',
        text: intl.get('toolbox.elements.variant_zone'),
      })
    }

    let ordered = defaultToolList

    const toolsOrder = window.org_settings && window.org_settings.tools
    if (toolsOrder) {
      const hash = defaultToolList.reduce((o, item) => {
        o[
          item.type === 'custom_embed' ? getKey(item.subtype) : item.type
        ] = item
        return o
      }, {})
      ordered = toolsOrder
        .map((key) => {
          return hash[key]
        })
        .filter((itm) => itm)
    }

    return ordered
  }
}

export default ['settingsService', 'evidentlyService', toolbox]
